import crudlModuleGenerator from '@/_CRUDL/modules/generator';

const multiple = 'comments';
const singleKey = 'comment';

const multipleEndpoint = `/proposals/:proposal_id/${multiple}`;
const singleEndpoint = `/proposals/:proposal_id/${multiple}/:id`;

export default crudlModuleGenerator('proposalComments', {
  customKeys: {
    create: singleKey,
    read: singleKey,
    update: singleKey,
    delete: singleKey,
    list: multiple,
  },
  customEndpoints: {
    create: multipleEndpoint,
    read: singleEndpoint,
    update: singleEndpoint,
    delete: singleEndpoint,
    list: multipleEndpoint,
  },
});
